/**
 * Module dependencies
 */
const querystring = require('querystring');

const { createAction } = require('redux-actions');

const { COMPONENT_ID } = require('../../../constants/app');
const PaymentMethodSearchService = require('../../../services/paymentMethodsSearch');
const {
  FETCH_PAYMENT_METHODS,
} = require('./types');

// Request Actions
const fetchePaymentMethods = createAction(FETCH_PAYMENT_METHODS);

/**
 * Export functions
 */
module.exports = {
  /**
   * Fetch payment methods fromt payment_methods/search
   * @return {function(*)}
   */
  [FETCH_PAYMENT_METHODS]: (paymentMethods) => (dispatch, getState) => {
    // simulate not having settings
    paymentMethods.forEach(pm => {
      delete pm.settings;
    })
    dispatch(fetchePaymentMethods(paymentMethods));
  },
};